/* eslint-disable react/prop-types */
import React, { Fragment, useState, Suspense } from 'react';
import { HashRouter as Router, Switch, Route, Link, Redirect } from 'react-router-dom';
import clsx from 'clsx';
import Drawer from '@material-ui/core/Drawer';
import Toolbar from '@material-ui/core/Toolbar';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import NavBar from '../../components/NavBar/NavBar';
import Logo from '../../assets/Images/logo.png';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import WelcomePage from './Contents/WelcomePage';
import Leaf from '../../assets/Images/svg/leaf.svg';
import NotePad from '../../assets/Images/notepad.png';
import OfferedDegreePrograms from './Contents/OfferedDegreePrograms';
import ALevelOfferedDegreePrograms from './Contents/ALevelOfferedDegreePrograms';
import EntryRequirements from './Contents/EntryRequirements';
import ALevelEntryRequirements from './Contents/ALevelEntryRequirements';
import MeritScholarship from './Contents/MeritScholarship';
import ConsultAdmissionCounselor from './Contents/ConsultAdmissionCounselor';
import AdmissionForm from './Contents/AdmissionForm/AdmissionForm';
import NewAdmission from './Contents/NewAdmission/NewAdmission';
import RegistrationFeePayment from './Contents/RegistrationFeePayment/RegistrationFeePayment';
import UploadDocumentsForm from './Contents/UploadDocuments/UploadDocumentsForm';
import ReviewAdmissionApplication from './Contents/ReviewAdmissionApplication';
import TutionFeePayment from './Contents/TutionFeePayment/TutionFeePayment';
import UploadRaisedDocumentsForm from './Contents/UploadDocuments/UploadRaisedDocumentsForm';
const drawerWidth = 283;

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuTitle: {
    backgroundColor: "#103C6E",
    fontFamily: 'sans-serif',
    display: 'flex',
    cursor: "default",
    fontSize: 16,
    fontWeight: 600,
    padding: 5,
    marginTop: 15
  },
  menuItemPadding: {
    padding: '0 !important',
    cursor: "pointer",
  },
  menuTitleIcon: {
    height: 25,
    width: 25,
    marginRight: 10,
    marginLeft: 15
  },
  menuItemText: {
    textAlign: 'left',
    paddingTop: 3,
    paddingBottom: 3,
    color: 'white',
    marginLeft: 40,
    width: drawerWidth - 20,
  },
  active: {
    backgroundColor: "#103C6E",
    paddingRight: 10,
    width: drawerWidth - 20,
    height: 30
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(1),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth
  },
  toolbar: theme.mixins.toolbar,
  drawer: {
    width: drawerWidth - 10,
  },
  drawerPaper: {
    width: drawerWidth,
    color: '#F5F5F5',
    backgroundColor: '#174A84',
  },
  drawerContainer: {
    overflow: 'auto',
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  regular: {
    minHeight: 0
  },
  menuListContainer: {
    borderLeft: '3px solid'
  }
}));

const SetRoute = ({ name, setValue, ...rest }) => {
  if ((name === "admission-application" && localStorage.getItem("isSubmitted") == 1) || (name === "documents" && localStorage.getItem("isDocumentRequested") != 1 && localStorage.getItem("isSubmitted") == 1)) {
    setValue('welcome');
    return (
      <Redirect to="/dashboard" />
    );
  } else {
    setValue(name);
    return (
      <Route {...rest} />
    );
  }
}

const NoFound = () => {
  return (
    <Redirect to="/dashboard" />
  )
}

const Dashboard = props => {
  const classes = useStyles();
  const [viewValue, setViewValue] = useState(props.match.params.value || "welcome");
  const [isDrawerOpen, setDrawerOpen] = useState(true);
  const userData = JSON.parse(localStorage.getItem('userData'));
  const isSubmitted = localStorage.getItem("isSubmitted");
  const isRaisedRequest = localStorage.getItem("isDocumentRequested");
  const isPreviousSessionStudent = localStorage.getItem("isPreviousSessionStudent");

  const handleValueChange = value => {
    setViewValue(value);
  }

  return (
    <Fragment>
      <NavBar logo={Logo} title="University College London." isAuthorize userName={userData.displayName} />
      <Drawer
        open={isDrawerOpen}
        onClose={() => setDrawerOpen(false)}
        className={classes.drawer}
        variant="persistent"
        anchor="left"
        classes={{
          paper: classes.drawerPaper
        }}
      >
        <Toolbar />
        <div className={classes.drawerContainer}>
          <div>

            <div className={classes.menuListContainer}>
              <Typography className={classes.menuTitle} noWrap variant="h6">
                <img alt="" className={classes.menuTitleIcon} src={Leaf} /> <div>Undergraduate Admission</div>
              </Typography>
              <MenuList>
                <MenuItem className={`${viewValue === "ug-degree-programs" && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/ug-degree-programs'>
                    <Typography className={classes.menuItemText} noWrap variant="body2">Offered Degree Programs</Typography>
                  </Link>
                </MenuItem>
                <MenuItem className={`${viewValue === "ug-entry-requirements" && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/ug-entry-requirements'>
                    <Typography className={classes.menuItemText} noWrap variant="body2">Entry Requirements</Typography>
                  </Link>
                </MenuItem>
                <MenuItem className={`${viewValue === "consult-admission-counselor" && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/consult-admission-counselor'> <Typography className={classes.menuItemText} variant="body2" noWrap>
                    Connect with our Counselors
                   </Typography>
                  </Link>
                </MenuItem>
              </MenuList>
            </div>

            <div className={classes.menuListContainer}>
              <Typography className={classes.menuTitle} noWrap variant="h6">
                <img alt="" className={classes.menuTitleIcon} src={Leaf} /> <div>GCE A-Level Admission</div>
              </Typography>
              <MenuList>
                <MenuItem className={`${viewValue === "al-degree-programs" && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/al-degree-programs'>
                    <Typography className={classes.menuItemText} noWrap variant="body2">Subject Choices</Typography>
                  </Link>
                </MenuItem>
                <MenuItem className={`${viewValue === "al-entry-requirements" && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/al-entry-requirements'>
                    <Typography className={classes.menuItemText} noWrap variant="body2">Entry Requirements</Typography>
                  </Link>
                </MenuItem>
                <MenuItem className={`${viewValue === "al-consult-admission-counselor" && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/al-consult-admission-counselor'> <Typography className={classes.menuItemText} variant="body2" noWrap>
                    Connect with our Counselors
                   </Typography>
                  </Link>
                </MenuItem>
              </MenuList>
            </div>

            <div className={classes.menuListContainer}>
              <Typography className={classes.menuTitle} noWrap variant="h6">
                <img alt="" className={classes.menuTitleIcon} src={NotePad} /> <div>Online Admission Process</div>
              </Typography>
              
              <MenuList>
              <MenuItem 
                disabled={isPreviousSessionStudent != 1} 
                className={`${viewValue === "documents" && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/new-admission'>
                    <Typography className={classes.menuItemText} noWrap variant="body2">New Admission</Typography>
                  </Link>
                </MenuItem>
                <MenuItem disabled={isSubmitted == 1} className={`${viewValue === "admission-application" && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/admission-application'>
                    <Typography className={classes.menuItemText} noWrap variant="body2">Admission Application</Typography>
                  </Link>
                </MenuItem>
                <MenuItem disabled={isSubmitted == 1 && isRaisedRequest != 1} className={`${viewValue === "documents" && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/documents'>
                    <Typography className={classes.menuItemText} noWrap variant="body2">Upload Documents</Typography>
                  </Link>
                </MenuItem>
                
                <MenuItem className={`${viewValue === "review" && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/review'> <Typography className={classes.menuItemText} variant="body2" noWrap>
                    Review & Submit Application
                   </Typography>
                  </Link>
                </MenuItem>
                <MenuItem className={`${(viewValue === "registration-fee-payment" || viewValue === "registration-fee-payment-success") && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/registration-fee-payment'> <Typography className={classes.menuItemText} variant="body2" noWrap>
                    Registration Fee Payment
                   </Typography>
                  </Link>
                </MenuItem>
                <MenuItem className={`${(viewValue === "tuition-fee-payment" || viewValue === "tuition-fee-payment-success") && classes.active} ${classes.menuItemPadding}`}>
                  <Link style={{ textDecoration: 'none' }} to='/dashboard/tuition-fee-payment'> <Typography className={classes.menuItemText} variant="body2" noWrap>
                    Tuition Fee Payment
                   </Typography>
                  </Link>
                </MenuItem>
              </MenuList>
            </div>

          </div>
          <div style={{ maxWidth: drawerWidth - 15, paddingBottom: 10, paddingTop: 20 }}>
            <Typography variant="body2" style={{ fontSize: 12, color: 'white' }} align="center">
              Copyright © {new Date().getFullYear()}. Universal College Lahore<br></br>(UCL), Pakistan - All Rights Reserved
              </Typography>
          </div>
        </div>
      </Drawer>

      <main className={clsx(classes.content, {
        [classes.contentShift]: isDrawerOpen,
      })}>
        <div className={classes.toolbar} />
        <Router>
          <Suspense fallback={<p>Loading...</p>}>
            <Switch>
              <SetRoute setValue={value => handleValueChange(value)} name="welcome" exact path="/dashboard" render={(props) => {
                return (
                  <WelcomePage {...props} title={userData.displayName} />
                )
              }} />
              <SetRoute setValue={value => handleValueChange(value)} name="ug-degree-programs" exact path="/dashboard/ug-degree-programs" component={OfferedDegreePrograms} />
              <SetRoute setValue={value => handleValueChange(value)} name="al-degree-programs" exact path="/dashboard/al-degree-programs" component={ALevelOfferedDegreePrograms} />
              <SetRoute setValue={value => handleValueChange(value)} name="ug-entry-requirements" exact path="/dashboard/ug-entry-requirements" component={EntryRequirements} />
              <SetRoute setValue={value => handleValueChange(value)} name="al-entry-requirements" exact path="/dashboard/al-entry-requirements" component={ALevelEntryRequirements} />
              <SetRoute setValue={value => handleValueChange(value)} name="merit-scholarship" exact path="/dashboard/merit-scholarship" component={MeritScholarship} />
              <SetRoute setValue={value => handleValueChange(value)} name="consult-admission-counselor" exact path="/dashboard/consult-admission-counselor" component={ConsultAdmissionCounselor} />
              <SetRoute setValue={value => handleValueChange(value)} name="al-consult-admission-counselor" exact path="/dashboard/al-consult-admission-counselor" component={ConsultAdmissionCounselor} />
              <SetRoute setValue={value => handleValueChange(value)} name="admission-application" exact path="/dashboard/admission-application" component={AdmissionForm} />
              <SetRoute setValue={value => handleValueChange(value)} name="new-admission" exact path="/dashboard/new-admission" component={NewAdmission} />
              <SetRoute setValue={value => handleValueChange(value)} name="registration-fee-payment" exact path="/dashboard/registration-fee-payment" component={RegistrationFeePayment} />
              <SetRoute setValue={value => handleValueChange(value)} name="registration-fee-payment-success" exact path="/dashboard/registration-fee-payment-success" render={(props) => {
                return (
                  <RegistrationFeePayment {...props} success />
                )
              }} />
              <SetRoute setValue={value => handleValueChange(value)} name="tuition-fee-payment" exact path="/dashboard/tuition-fee-payment" component={TutionFeePayment} />
              <SetRoute setValue={value => handleValueChange(value)} name="tuition-fee-payment-success" exact path="/dashboard/tuition-fee-payment-success" render={(props) => {
                return (
                  <TutionFeePayment {...props} success />
                )
              }} />
              <SetRoute setValue={value => handleValueChange(value)} name="documents" exact path="/dashboard/documents" component={localStorage.getItem("isDocumentRequested") == 1 ?
                UploadRaisedDocumentsForm : UploadDocumentsForm} />
              <SetRoute setValue={value => handleValueChange(value)} name="review" exact path="/dashboard/review" component={ReviewAdmissionApplication} />
              <SetRoute setValue={value => handleValueChange(value)} name="home" exact path="*" component={NoFound} />
            </Switch>
          </Suspense>
        </Router>
      </main>
    </Fragment>
  );
}

export default Dashboard;
